// import { GlobalStyles } from './global';
import { defaultColors } from "./colors";
import { mediaQueries } from "./custom-queries";

const theme = {
  defaultColors,
  mediaQueries,
};

export default theme;
